module.exports = __webpack_public_path__ + "img/public/SiteIcons/stepEditArrow.svg?bc987c4f";